import { render, staticRenderFns } from "./PortalChart.vue?vue&type=template&id=99af4d32&"
import script from "./PortalChart.vue?vue&type=script&lang=js&"
export * from "./PortalChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports